import * as React from "react";
export const PlusIcon = () => (React.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 17 16", fill: "none" },
    React.createElement("path", { d: "M4.5 8h4m0 0h4m-4 0V4m0 4v4", stroke: "#0E1D31", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" })));
